<div [class]="containerClass" [ngStyle]="{ height: height }"></div>
